import { HttpBackend, HttpClient } from '@angular/common/http';
import {CommonModule, LOCATION_INITIALIZED} from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {ErrorHandler, NgModule} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { ApmErrorHandler, ApmModule } from "@elastic/apm-rum-angular";

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MainHomeComponent } from './components/main-home/main-home.component';
import { HttpRequestInterceptor } from './helpers/interceptors/auth-interceptor';
import { RefreshInterceptor } from './helpers/interceptors/refresh-interceptor';
import { AppLayoutModule } from './layout/app.layout.module';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from 'src/environments/environment';
import { AuthConstants } from './constants/auth/auth-constants';
import { EditorModule } from "primeng/editor";
import { TextEditorComponent } from './components/tools/text-editor/text-editor.component';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { SignedInGuard } from './helpers/guards/signed-in.guard';

import { MesRemboursementsComponent } from './components/mes-remboursements/mes-remboursements.component';
import { DemanderRemboursementsComponent } from './components/demander-remboursements/demander-remboursements.component';
import { LibDemandeRemboursementModule } from 'lib-demande-remboursement';
import { LibAccueilModule } from 'lib-accueil';
import {CardModule} from 'primeng/card';
import { MonProfilComponent } from './components/mon-profil/mon-profil.component';
import { DemandeAnalyseDevisComponent } from './components/demande-analyse-devis/demande-analyse-devis.component';
import { LibDemandeAnalyseDevisModule } from 'lib-demande-analyse-devis';
import { MesCourriersModule  } from 'mes-courriers';
import {  MesRemboursementsModule } from 'mes-remboursements';
import {  DemandeHospiModule } from 'lib-demande-hospitaliere';
import {  NousContacterModule } from 'lib-nous-contacter';
import {  SuiviDemandesModule } from 'suivi-demandes';
import {  CoordonneesBancairesModule } from 'coordonnees-bancaires';
import {  GererMesBeneficiairesModule } from 'gerer-mes-beneficiaires';
import {  MenuNouveautesModule } from 'lib-menu-nouveautes';
import {  DemandeResiliationModule  } from 'demande-resiliation';
import {  MonAdhesionModule } from 'mon-adhesion';
import {  GestionContratModule } from 'gestion-contrat';
import {  RemboursementCapitalDecesModule } from 'remboursement-capital-deces';
import {  PaiementEnLigneModule } from 'lib-paiement-en-ligne';
import { LibFaqModule } from 'lib-faq';
import { DemandeHospitalisationComponent } from './components/demande-hospitalisation/demande-hospitalisation.component';
import { LibMonProfilModule } from 'lib-mon-profil';
import { FaqComponent } from './components/faq/faq.component';
import { MesCourriersComponent } from './components/mes-courriers/mes-courriers.component';
import { SuiviDemandesComponent } from './components/suivi-demandes/suivi-demandes.component';
import { CoordonneesBancairesComponent } from './components/coordonnees-bancaires/coordonnees-bancaires.component';
import { GererMesBenefsComponent } from './components/gerer-mes-benefs/gerer-mes-benefs.component';
import { MesDocumentsContractuelsComponent } from './components/mes-documents-contractuels/mes-documents-contractuels.component';
import { LibDocumentsModule } from 'lib-documents';
import { NousContacterComponent } from './components/nous-contacter/nous-contacter.component';
import {AffichageCguModule} from "./components/affichage-cgu/affichage-cgu.module";
import { MonAdhesionComponent } from './components/mon-adhesion/mon-adhesion.component';
import { DemandeResilisationComponent } from './components/demande-resilisation/demande-resilisation.component';
import { DetailsRemboursementsModule } from 'lib-details-remboursements';
import { GestionContratDCComponent } from './components/gestion-contrat-dc/gestion-contrat-dc.component';
import { MesservicesComponent } from './layout/messervices/messervices.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { RemboursementCapitalDecesComponent } from './components/remboursement-capital-deces/remboursement-capital-deces.component'
import { CotisationsComponent } from './components/cotisations/cotisations.component'
import { LibListeCotisationModule} from 'lib-cotisation';
import { TableModule } from 'primeng/table';
import { TimeoutComponent } from './helpers/timeout/timeout.component';
import { AuthSharedModule } from './shared/auth-shared.module';
import { commentpipe } from './layout/messervices/commentpipe ';
import { MessagesModule } from 'primeng/messages';
import { CarteTpModule } from 'lib-carte-tp';
import { MesCartesTiersPayantComponent } from './components/mes-cartes-tiers-payant/mes-cartes-tiers-payant.component';
import { LoginModule } from "./components/auth/login/login.module";
import { EnvironmentProvider } from './providers/environment.provider';
import { ForbiddenInterceptor } from './helpers/interceptors/forbidden-interceptor';
import {TranslationUtil} from "./utils/translation-util";
import {MenuUtil} from "./utils/menu-utils";
import {PageServiceService} from "./layout/service/page-service.service";
import {Router} from "@angular/router";
import {TableUtils} from "./utils/table-utils";
import {DecimalFormatterDirective} from "./directives/decimal-formatter-directive";
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { CookieErrorComponent } from './components/cookie-consent-error-page/cookie-error.component';
import { LibTeleconsultationMaiiaModule } from 'lib-teleconsultation-maiia';
import { MaiiaComponent } from './components/maiia/maiia.component';
import { SharedModule } from './shared/shared/shared.module';
import {GlobalUtils} from "./utils/global-utils";
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EnvironmentService } from './services/environment.service';
import { ConfigurationProvider } from './providers/configuration.provider';
import { ConfigurationService } from './services/configuration.service';
import { CustomTranslateLoader } from './services/language/custom-translate-loader';

export function getServerUrl(environmentService: EnvironmentService): string {
  return environmentService.get('serverUrl') as string;
}
@NgModule({
  declarations: [
    commentpipe,
    AppComponent,
    MainHomeComponent,
    TextEditorComponent,
    MesRemboursementsComponent,
    DemanderRemboursementsComponent,
    DecimalFormatterDirective,
    MonProfilComponent,
    DemandeAnalyseDevisComponent,
    DemandeHospitalisationComponent,
    FaqComponent,
    MesCourriersComponent,
    SuiviDemandesComponent,
    CoordonneesBancairesComponent,
    GererMesBenefsComponent,
    MesDocumentsContractuelsComponent,
    NousContacterComponent,
    MonAdhesionComponent,
    DemandeResilisationComponent,
    MesservicesComponent,
    DemandeResilisationComponent,
    GestionContratDCComponent,
    RemboursementCapitalDecesComponent,
    CotisationsComponent,
    TextEditorComponent,
    TimeoutComponent,
    MesCartesTiersPayantComponent,
    CookieErrorComponent,
    MaiiaComponent
  ],
  imports: [
    SharedModule,
    ApmModule,
    BrowserModule,
    AppRoutingModule,
    AppLayoutModule,
    CommonModule,
    RippleModule,
    InputTextModule,
    ButtonModule,
    FormsModule,
    TooltipModule,
    LibFaqModule,
    MesCourriersModule,
    CarteTpModule,
    LoginModule,
    EditorModule,
    ToastModule,
    CardModule,
    MesRemboursementsModule,
    LibDemandeRemboursementModule,
    LibAccueilModule,
    LibDemandeAnalyseDevisModule,
    DemandeHospiModule,
    LibMonProfilModule,
    NousContacterModule,
    SuiviDemandesModule,
    CoordonneesBancairesModule,
    GererMesBeneficiairesModule,
    LibDocumentsModule,
    ProgressSpinnerModule,
    LibListeCotisationModule,
    MenuNouveautesModule,
    MessagesModule,
    TableModule,
    TranslateModule.forRoot({
      defaultLanguage: 'fr',
      extend: true,
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader,
        deps: [HttpBackend]
      }
    }),
    AffichageCguModule,
    AuthSharedModule,
    DemandeResiliationModule,
    DetailsRemboursementsModule,
    MonAdhesionModule,
    GestionContratModule,
    RemboursementCapitalDecesModule,
    LibListeCotisationModule,
    PaiementEnLigneModule,
    LibTeleconsultationMaiiaModule,
    NgxIntlTelInputModule,
    BrowserAnimationsModule

  ],
  providers: [
    ConfigurationProvider,
    EnvironmentProvider,
    {
      provide: ErrorHandler,
      useClass: ApmErrorHandler,
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    {
      provide: AuthConstants.SERVER_URL,
      useFactory: getServerUrl,
      deps: [EnvironmentService],
    },
    CookieService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshInterceptor,
      multi: true
    },
    {
      provide: 'TableUtils',
      useValue: TableUtils
    },
    {
      provide: 'TranslationUtil',
      useValue: TranslationUtil
    },
    {
      provide: 'GlobalUtils',
      useValue: GlobalUtils
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ForbiddenInterceptor,
      multi: true
    },
    SignedInGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(translateService: TranslateService, pageSService: PageServiceService, routerService: Router,cookieService: CookieService, private configurationService: ConfigurationService) {
    TranslationUtil.setTranslateService(translateService);
    MenuUtil.setService(pageSService);
    MenuUtil.setCookieService(cookieService);
    MenuUtil.setRouter(routerService);
    TableUtils.setConfigurationService(configurationService);
  }
}
